import * as React from 'react';

import DeliverableInfoCopyControl from '../deliverable-info-copy-control/DeliverableInfoCopyControl';

import './deliverable-tag-view.scss';

type Props = {
  deliverableId: number,
  deliverableActionType: string,
  tags: Array<string>,
  title: string
}

const DeliverableTagView = ({ deliverableId, deliverableActionType, tags, title }: Props) => (
  <div className="deliverable-tag-view">
    <div className="deliverable-tag-view__section-title">
      {title}
      <DeliverableInfoCopyControl
        uniqueKey={`${deliverableId}-${deliverableActionType}`}
        wrapperClass="deliverable-tag-view__tags-copy"
      />
    </div>
    <div
      className="deliverable-tag-view__tag"
      data-copy-key={`${deliverableId}-${deliverableActionType}-field-to-copy`}
    >
      {`${tags?.join(' ')}`}
    </div>
  </div>
);

export default DeliverableTagView;
